import React, { PropsWithChildren, ReactNode } from 'react';
import clx from 'classnames';
import { Header, HeaderIndex } from '../Header/Header';
import { Footer } from '../Footer/Footer';

import styles from './Layout.module.scss';

export const SettingPageLayout = (props: PropsWithChildren<ReactNode>) => {
    return (
        <div className={styles.layout__container}>
            <Header />
            {props.children}
        </div>
    );
};

export const IndexLayout = (props: PropsWithChildren<ReactNode>) => {
    return (
        <div className={clx(styles.layout__container, styles.layout__container_indexPage)}>
            <HeaderIndex />
            {props.children}
            <Footer />
        </div>
    );
};
